import { createAction } from 'redux-actions';
export var addFragment = createAction('ADD_FRAGMENT');
export var updateFragment = createAction('UPDATE_FRAGMENT');
export var updateRoute = createAction('UPDATE_ROUTE');
export var setGlobalStyle = createAction('SET_GLOBAL_STYLE');


//////////////////
// WEBPACK FOOTER
// ./node_modules/spectacle/es/actions/index.js
// module id = 162
// module chunks = 0